<template>
    <v-dialog v-model="active" width="680">
        <template v-slot:activator="{ on }">
          <slot name="activator" v-bind="{ on: on }" />
        </template>

        <v-card>
            <v-card-title dark class="dialog-titulo">
                Nota Fiscal
            </v-card-title>
            <v-card-text class="pb-0 mb-0 pt-3">
                <v-form ref="formSaiuParaEntrega">
                <v-row class="flex-column pl-3">
                    <span class="dialog-label">Data de expedição</span>
                    <span class="dialog-info">{{ pedido.dtPrevisaoEntrega | formataData(false, 'DD/MM/YYYY') }}</span>
                </v-row>

                <v-row dense>
                    <v-col cols="3">
                        <span class="dialog-label">Número da Nota Fiscal</span>
                        <v-text-field v-model="pedido.nrNotaFiscal" color="#008EF0" outlined dense
                                      :rules="[OBRIGATORIO]"
                                      :filled="readOnly" :readonly="readOnly" v-mask="'####-##'" />
                    </v-col>
                    <v-col cols="3">
                        <span class="dialog-label">Quantidade de Itens</span>
                        <v-text-field v-model="pedido.qtItensNF" color="#008EF0" outlined dense v-only-number
                                      :filled="readOnly" :readonly="readOnly" type="number" :rules="[MIN_0, OBRIGATORIO]"
                                      v-on:change="renderRows($event)" />
                    </v-col>
                </v-row>
                <v-row dense v-for="(item, key) in pedido.racoes" :key="key">
                    <v-col class="my-0 py-0" cols="5">
                        <span class="dialog-label">Seleção de ração</span>
                        <v-autocomplete color="#008EF0" outlined dense :items="listaRacao" hide-no-data allow-overflow
                                        item-value="cdItem" item-text="nmRacao" :rules="[OBRIGATORIO]"
                                        v-model="pedido.racoes[key].codigo" :filled="readOnly" :readonly="readOnly"  />
                    </v-col>
                        <v-col class="my-0 py-0" cols="3">
                            <span class="dialog-label">Quantidade de Ração</span>
                            <v-text-field color="#008EF0" outlined v-model="pedido.racoes[key].quantidade"
                                          :rules="[OBRIGATORIO]"
                                          dense v-only-number :filled="readOnly" :readonly="readOnly">
                                <template v-slot:append>
                                    <span class="kilo">Kg</span>
                                </template>
                            </v-text-field>
                        </v-col>

                        <v-col class="my-0 py-0" cols="3">
                            <span class="dialog-label">Partida/Lote</span>
                            <v-text-field v-model="pedido.racoes[key].lote" color="#008EF0" outlined dense
                                          v-only-number
                                          :filled="readOnly" :readonly="readOnly" />
                        </v-col>
                </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="mx-3 pb-4">
                <v-btn class="btn-cancelar" color="#FF5252" outlined
                       @click="$emit('update:saiuEntregaDialog', false);">
                    Voltar
                </v-btn>
                <v-spacer/>
                <v-btn v-if="!readOnly" color="#2BC1B6" elevation="0" class="ml-2 white--text" @click="validarForm()">
                    Saiu para Entrega
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import {mask} from 'vue-the-mask';
import * as moment from "moment";
import {RULES} from '@/modules/pedidosRacao/resources';

export default {
    name: 'nota-fiscal-dialog',
    directives: {mask},
    components: { RULES },
    computed: {
        active: {
            get() { return this.saiuEntregaDialog },
            set(v) { this.$emit('update:saiuEntregaDialog', v) }
        }
    },
    methods: {
        ...RULES,
        renderRows(v) {
            const qtd = Number.parseInt(v);
            const qtdAtual = this.pedido.racoes.length;

            if (qtd > qtdAtual) {
                for (let i = qtdAtual; i < qtd; i++) {
                    this.pedido.racoes.push({codigo: '', quantidade: 0, lote: ''});
                }
                this.$refs.formSaiuParaEntrega.resetValidation();
            }
            if (qtd < qtdAtual) {
                this.pedido.racoes.splice(qtd - qtdAtual, qtdAtual - qtd);
                this.$refs.formSaiuParaEntrega.resetValidation();
            }
        },
        validarForm(){
            if(this.$refs.formSaiuParaEntrega.validate()) {
                this.$emit('update:saiuEntregaDialog', false);
                this.$emit('lancarNF');
            }
        }
    },
    filters: {
        formataData(date, ISO, formatoSaida) {
            let tipoData = ISO ? moment.ISO_8601 : 'YYYY-MM-DD';
            const parsedDate = moment(date, tipoData);
            if (!parsedDate.isValid()) return "";
            return parsedDate.format(formatoSaida);
        },
    },
    props: {
        pedido: {},
        saiuEntregaDialog: {
            type: Boolean,
            default: true
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        listaRacao: {
            type: Array,
            default: []
        }
    }
}
</script>
<style lang="scss" scoped>
@import "src/modules/pedidosRacao/sass/variables";

.dialog-label {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0px;
  color: $gray-300;
}

.dialog-info {
  font: normal normal bold 22px/30px Roboto;
  letter-spacing: 0;
  color: $gray-200;
  text-transform: capitalize;
}

.dialog-titulo {
  text-align: left;
  font: normal 300 normal 16px/21px Roboto !important;
  letter-spacing: 0;
  color: $gray-500;
  opacity: 1;
  background-color: $gray-100;
}

.kilo {
  color: $gray-200;
  font: normal 500 normal 14px/21px Roboto;
  margin-top: 2px;
}
</style>